<template>
    <el-footer class="footer">
        <el-row align="middle" justify="center">
            <el-col :span="24">
                <el-text>Copyright &copy; 2023~2025 DSX TECH. All rights reserved.</el-text>
                <el-divider direction="vertical"></el-divider>
                <el-link href="https://beian.miit.gov.cn" target="_blank" underline="never">
                    沪ICP备2025134987号-1
                </el-link>
            </el-col>
        </el-row>
    </el-footer>
    <el-backtop :bottom="100" :right="100"/>
</template>

<script setup>

</script>

<style scoped>
.footer {
    background-color: #322828;
    padding: 20px 0;
    align-items: center;
}

.el-text, .el-link {
    color: white;
    font-size: 15px;
}


</style>